import _ from 'lodash';
import { SearchStringSchema } from '../common/schemas';
import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn, createTransformer } from '../common/utils';
import { SchoolAttributes } from './constants';
import { DBSchoolSchema, SchoolSchema } from './schemas';

export const SchoolCodecConfig: TransformerConfig<typeof SchoolSchema, typeof DBSchoolSchema> = {
  name: 'School',
  clientSchema: SchoolSchema,
  dbSchema: DBSchoolSchema,
  transformers: [
    // Handle search string updates
    createTransformer<typeof SchoolSchema, typeof DBSchoolSchema>({
      encoder: {
        sourceFields: SchoolAttributes.Search,
        // Only label is a dependency: an update may leave out the short label and
        // abbreviation, which then fall back to the existing school
        dependencies: ['label'] as const,
        encode: (school, oldSchool) => {
          let searchStr = '';
          SchoolAttributes.Search.forEach(attr => {
            const val = school?.[attr] ?? oldSchool?.[attr] ?? '';
            // Truncate per field and after concatenation: SearchStringSchema
            // caps search strings at 255 characters, while a label alone may
            // reach 256
            searchStr += SearchStringSchema.parse(val.slice(0, 255));
          });
          return { searchStr: searchStr.slice(0, 255), ..._.pick(school, SchoolAttributes.Search) };
        },
      },
    }),
  ],
};

export const encodeSchoolToDb = createEncodeToDbFn(SchoolCodecConfig);
export const decodeSchoolFromDb = createDecodeFromDbFn(SchoolCodecConfig);
